import {useCallback, useEffect, useState} from 'react';
import * as AutoSaveRecentKeywordStorage from './autoSaveRecentKeyword.storage';

export function useAutoSaveRecentKeyword() {
  const [autoSaveRecentKeyword, _setAutoSaveRecentKeyword] = useState(true);

  useEffect(() => {
    _setAutoSaveRecentKeyword(
      AutoSaveRecentKeywordStorage.getAutoSaveRecentKeyword()
    );
  }, []);

  const setAutoSaveRecentKeyword = useCallback((autoSave: boolean) => {
    AutoSaveRecentKeywordStorage.setAutoSaveRecentKeyword(autoSave);
    _setAutoSaveRecentKeyword(autoSave);
  }, []);

  return {
    autoSaveRecentKeyword,
    setAutoSaveRecentKeyword,
  };
}
